const routes = {
  auth: '/',
  joinAccountFirst: '/invite-partner-account-employee',
  joinAccountSecond: '/join-account-second-step',
  joinAccountDisabled: '/join-account-disabled',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  resetPasswordDone: '/reset-password-done',
  myProfile: '/my-profile/:tab',
  accounts: '/accounts',
  dnsZones: '/dns-zones',
  accountEdit: '/edit-account/:tab/:id',
  accountEditUser: '/edit-account/:tab/:id/edit-user/:userId',
  accountAccessGroup: '/edit-account/:tab/:id/access-groups/:groupId/:accessTab',
  accountMembersEdit: '/settings-account-members/:tab/:id',
  users: '/users',
  netProtection: '/net-protection/:tab',
  appProtection: '/app-protection/:tab',
  anomalyDetails: '/anomaly-details/:tab/:backLink/:id/:indexPage',
  mitigationsDetails: '/mitigations-details/:backLink/:start/:mitigationId/:id/:indexPage',
  dnsHosting: '/edit-account/:tab/:id/:subTab',
  netProtectionV2: '/network-protectionV2/:tab',
  netProtectionV2Protected: '/network-protectionV2/protected-profiles',
  netProtectionV2Monitoring: '/network-protectionV2/monitoring-objects',
};

export default routes;
